import script from "./BuyerDashboardGenderLwBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardGenderLwBarChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardGenderLwBarChart.vue?vue&type=style&index=0&id=e48633ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48633ba"]])

export default __exports__